import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import Wizardable from '../../components/widgets/Wizardable';
import WizardFooter from '../../components/widgets/WizardFooter';
import AddFutureItems from '../containers/AddFutureItems';
import { translationPrefix } from '../utils';
import SearchableMultiSelect from './SearchableMultiSelect';
import css from './GenericDimensionSelection.css';

class GenericDimensionSelection extends Wizardable {
    constructor(props) {
        super(props);
        this.buttonOverrides = props.wizardOverrideButtons || {};
    }

    selectAll = shouldSelectAll => {
        const {
            permissionDimension: { values },
            setDimensionFilterValues,
            enableAddFuture,
        } = this.props;
        setDimensionFilterValues(shouldSelectAll ? values.map(x => x.name) : []);
        if (shouldSelectAll) {
            enableAddFuture();
        }
    };

    validate() {
        const {
            translate = () => '',
            permissionDimension: { name, displayName, selected },
        } = this.props;
        const isValid = selected?.values.length > 0;
        const itemType = (displayName || name || '').toLowerCase();

        const tooltipButtons = ['next'];
        this.setTooltip(
            tooltipButtons,
            isValid
                ? null
                : translate('STATIC.PAGES.TEAM_MEMBERS.SELECT_AT_LEAST_ONE_TOOLTIP', {
                      itemType,
                  })
        );

        return isValid;
    }

    onItemSelected = (id, selected) => {
        const { setDimensionFilterValues, permissionDimension } = this.props;
        const selectedValues = (permissionDimension.selected && permissionDimension.selected.values) || [];
        if (!selected && selectedValues.includes(id)) {
            setDimensionFilterValues(selectedValues.filter(x => x !== id));
        } else if (selected && !selectedValues.includes(id)) {
            setDimensionFilterValues([...selectedValues, id]);
        }
    };

    render() {
        const {
            permissionDimension: { name, displayName, values, selected },
            lastAction,
            translate = () => '',
        } = this.props;
        const dimension = (displayName || name || '').toLowerCase();
        const selectedValues = selected.values || [];
        const allItems = values.map(value => ({
            id: value.name,
            name: value.name,
            displayName: value.displayName,
            selected: selectedValues.includes(value.name),
        }));
        return (
            <>
                <this.AnimationItem initialPose={lastAction} pose="visible" className={css.page}>
                    <div className={css.headline}>
                        <div className={css.preamble}>
                            <Translate
                                id="STATIC.PAGES.TEAM_MEMBERS.WIZARD_STEP_DIMENSION_FILTER_TITLE"
                                data={{ dimension }}
                            />
                            <div className={css.faqLine}>
                                <Translate
                                    id="STATIC.PAGES.TEAM_MEMBERS.WIZARD_STEP_DIMENSION_FILTER_DESCRIPTION"
                                    data={{ dimension }}
                                />
                            </div>
                        </div>
                        <div className={css.selectorContainer}>
                            <div className={css.counter}>
                                {translate(`${translationPrefix}.SELECTED_COUNT`, {
                                    selectedCount: selectedValues.length,
                                    totalCount: values.length,
                                })}
                            </div>
                        </div>
                    </div>
                    <SearchableMultiSelect
                        className={css.multiSelectContainer}
                        allItems={allItems}
                        filteredItems={allItems}
                        onChange={this.onItemSelected}
                        selectAll={this.selectAll}
                        searchPlaceholder={translate(`${translationPrefix}.PLACEHOLDER.GENERIC_DIMENSION_SEARCH`, {
                            dimension,
                        })}
                        showIcon={false}
                    />
                </this.AnimationItem>
                <WizardFooter
                    buttons={this.getButtons()}
                    leftComponents={<AddFutureItems itemType={`${dimension} values`} form={name} dimensionFilter />}
                />
            </>
        );
    }
}

GenericDimensionSelection.propTypes = {
    permissionDimension: PropTypes.shape({
        name: PropTypes.string.isRequired,
        displayName: PropTypes.string,
        values: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                displayName: PropTypes.string.isRequired,
            })
        ).isRequired,
        selected: PropTypes.shape({
            values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
            addFuture: PropTypes.bool,
        }).isRequired,
    }).isRequired,
    wizardOverrideButtons: PropTypes.objectOf(PropTypes.any),
    translate: PropTypes.func,
};

export default GenericDimensionSelection;
